const TOKEN_KEY = "session_key";
const TOKEN_EXPIRY_KEY = "session_key_expiry";
const IMPERSONATION_KEY = "impersonation_session";

export function isImpersonationWindow() {
    return sessionStorage.getItem(IMPERSONATION_KEY) === "true";
}

function tokenStorage() {
    // Keep the marker after logout/expiry so a popup never falls back to the admin token.
    return isImpersonationWindow() ? sessionStorage : localStorage;
}

export function getToken() {
    return tokenStorage().getItem(TOKEN_KEY);
}

export function setToken(token, expiresAt) {
    const storage = tokenStorage();
    storage.setItem(TOKEN_KEY, token);
    if (expiresAt) storage.setItem(TOKEN_EXPIRY_KEY, expiresAt.toString());
    else storage.removeItem(TOKEN_EXPIRY_KEY);
}

export function clearToken() {
    const storage = tokenStorage();
    storage.removeItem(TOKEN_KEY);
    storage.removeItem(TOKEN_EXPIRY_KEY);
}

export function isTokenExpired() {
    const expiry = Number(tokenStorage().getItem(TOKEN_EXPIRY_KEY));
    return !Number.isFinite(expiry) || Date.now() >= expiry * 1000;
}

export function setImpersonationSession(storage, token, expiresAt) {
    storage.setItem(IMPERSONATION_KEY, "true");
    storage.setItem(TOKEN_KEY, token);
    storage.setItem(TOKEN_EXPIRY_KEY, expiresAt.toString());
}
